import {FilterOption} from 'search/filters/base/FilterComponents';
import {FilterKey} from 'search/SearchConstants';

export function getContainerConcentrationFilter(): Array<FilterOption> {
  return [{filterKey: FilterKey.CONTAINER_CONCENTRATION}];
}
